import { render } from "./GalleryManagement.vue?vue&type=template&id=84e14e7e&ts=true"
import script from "./GalleryManagement.vue?vue&type=script&lang=ts"
export * from "./GalleryManagement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__